import EventEmitter from 'eventemitter3';
export class MessageValidatorWrapper extends EventEmitter {
    worker;
    validate(publisher, contentMessage, streamMessage) {
        this.worker?.postMessage({
            type: 'validate',
            data: {
                publisher,
                contentMessage,
                streamMessage,
            },
        });
    }
    startWorker() {
        return new Promise((resolve, _reject) => {
            this.worker = new Worker(new URL('./workers/messagevalidator.worker.ts', import.meta.url));
            this.worker.onmessage = (e) => {
                const { type, data } = e.data;
                switch (type) {
                    case 'validatedData':
                        this.emit('validatedData', data.contentMessage);
                        break;
                    case 'initCompleted':
                        resolve();
                        break;
                }
            };
            this.worker.postMessage({
                type: 'init',
            });
        });
    }
    async init() {
        try {
            // Decode in another web worker
            console.log('Starting MessageValidatorWorker');
            await this.startWorker();
        }
        catch (e) {
            console.log('MessageValidatorWorker::start error', e);
        }
    }
}
